// @flow

import './index.scss';
import * as React from 'react';
import { useTranslate } from '@insolus/react-i18n';
import formatAmount from 'utils/formatAmount';

type Props = {|
    value: number | null,
    decimal?: boolean,
    taxExcl?: boolean,
    currency?: string
|};

const Price = ({ value, decimal = false, taxExcl = false, currency = 'CHF' }: Props): React.Node => {
    const { __ } = useTranslate();
    let amount = null;
    if (value) {
        amount = formatAmount(value, { currency: false, decimal: decimal ? 2 : 0 });
    }
    return (
        <data value={amount} className="Price">
            <span className="Price__currency">
                {currency}
            </span>
            {'\u00A0'}
            <span className="Price__amount">
                {amount ? `${amount}${decimal ? '' : '.-'}` : __('price-on-demand')}
            </span>
            {(taxExcl && amount) && <span className="Price__amount">{__('tax-excl')}</span>}
        </data>
    );
};

export default (React.memo<Props>(Price): React$AbstractComponent<Props, mixed>);
